import { useState } from 'react';
import { JSONTree } from 'react-json-tree';

import { Box, IconButton, useTheme } from '@mui/material';

import { IcRapidSOSIcon } from '@/assets/images';
import { AppModal } from '@/components';
import { withLoader } from '@/hocs';
import { useCFSContext } from '@/hooks';

import { RapidSOSRoot } from './styles';

const theme = {
  base00: '#2b303b',
  base01: '#343d46',
  base02: '#4f5b66',
  base03: '#65737e',
  base04: '#a7adba',
  base05: '#c0c5ce',
  base06: '#dfe1e8',
  base07: '#eff1f5',
  base08: '#bf616a',
  base09: '#d08770',
  base0A: '#ebcb8b',
  base0B: '#a3be8c',
  base0C: '#96b5b4',
  base0D: '#8fa1b3',
  base0E: '#b48ead',
  base0F: '#ab7967',
};

const RapidSOSAdditionalDataModal = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { additionalData, locations } = useCFSContext();
  const t = useTheme();

  const onClose = () => {
    setOpenModal(false);
  };

  // We only show rapidsos data if all rapidsos data is present.
  if (!additionalData || !locations || locations.length === 0) {
    return null;
  }
  return (
    <RapidSOSRoot>
      <IconButton onClick={() => setOpenModal(true)}>
        <IcRapidSOSIcon />
      </IconButton>
      <AppModal
        open={openModal}
        title="Rapid SOS Person Data"
        onClose={onClose}
      >
        <Box sx={{ maxHeight: '600px', overflowY: 'auto' }}>
          <JSONTree
            data={additionalData}
            theme={theme}
            invertTheme={t.palette.mode === 'light'}
            hideRoot={true}
            getItemString={() => <span></span>}
          />
        </Box>
      </AppModal>
    </RapidSOSRoot>
  );
};

export default withLoader(RapidSOSAdditionalDataModal);
